// File upload fields (.widget--file): dropping files on the label (the dropzone) hands them to the input, so the
// framework's upload.js lists them as if they were chosen in the dialog.
export function initFileDrop() {
	document.querySelectorAll('.widget--file').forEach((widget) => {
		const input = widget.querySelector('input[type="file"]')
		const zone = widget.querySelector('label')
		if (!input || !zone) return
		const stop = (e) => { e.preventDefault(); e.stopPropagation() }
		zone.addEventListener('dragover', (e) => { stop(e); zone.classList.add('is-dragover') })
		zone.addEventListener('dragleave', () => zone.classList.remove('is-dragover'))
		zone.addEventListener('drop', (e) => {
			stop(e)
			zone.classList.remove('is-dragover')
			if (!e.dataTransfer?.files?.length) return
			const files = new DataTransfer()
			;[...e.dataTransfer.files].slice(0, input.multiple ? undefined : 1).forEach((f) => files.items.add(f))
			input.files = files.files
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	})
}
